import React, { useState, useEffect } from "react";
import logo from "../assets/images/endless-logo.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { LOGIN_SUCCESS } from "../redux/actionTypes";
import { login } from "../api/authAPI";
import { showToast } from "../components/ToastifyNotification";

// Validation schema using Yup
const schema = yup.object().shape({
  userName: yup.string().required("userName is required"),
  password: yup.string().required("Password is required")
});

const Signin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state?.authReducer?.isAuthenticated || false);
  const company = useSelector(state => state?.authReducer?.company || {});
  const finaicialYear = useSelector(state => state?.authReducer?.finaicialYear || {});

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

useEffect(() => {
  if (isAuthenticated && company && finaicialYear) {
    navigate('/dashboard/default');
  }
}, [isAuthenticated, company, finaicialYear]); 

// if (isAuthenticated) {
//   navigate(`/dashboard/default`);
// }

  

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await login(data);
      if (response.success) {
        showToast('success',response.message);
        dispatch({ type: LOGIN_SUCCESS, payload: { response } });
        setTimeout(() => {
          navigate('/company-selection');
        }, 100);
      } else {
        showToast('error',response.message);
      }
    } catch (error) {
      showToast('error',error.message);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid p-0">
        <div className="authentication-main">
          <div className="row">
            <div className="col-md-12">
              <div className="auth-innerright">
                <div className="authentication-box">
                  <div className="text-center">
                    {/* <img src={logo} alt="" /> */}
                    HOSPITAL MANAGEMENT SOFTWARE
                  </div>
                  <div className="card mt-4">
                    <div className="card-body">
                      <div className="text-center">
                        <h4>LOGIN</h4>
                        <h6>Enter your Username and Password</h6>
                      </div>
                      <form
                        className="theme-form"
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <div className="form-group">
                          <label className="col-form-label pt-0">Username</label>
                          <input
                            className="form-control"
                            type="userName"
                            placeholder="Username"
                            {...register("userName")}
                          />
                          {errors.userName &&
                            <small className="text-danger">
                              {errors.userName.message}
                            </small>}
                        </div>
                        <div className="form-group">
                          <label className="col-form-label">Password</label>
                          <input
                            className="form-control"
                            type="password"
                            placeholder="Password"
                            {...register("password")}
                          />
                          {errors.password &&
                            <small className="text-danger">
                              {errors.password.message}
                            </small>}
                        </div>
                        <div className="checkbox p-0">
                          <input id="checkbox1" type="checkbox" />
                          <label htmlFor="checkbox1">Remember me</label>
                        </div>
                        <div className="form-group form-row mt-3 mb-0 d-grid">
                          <button className="btn btn-primary" type="submit">
                            Login
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
